<!-- 顶部LOGO、搜索栏、导航栏组件 -->
<template>
  <div class="bottom" >
    <div class="ChangeLanguage" @click="ChangeLanguage">
      [<span  :class="{'active': currentLanguage === 'Chinese'}" > CN</span>/<span :class="{'active': currentLanguage === 'English'}" >EN</span>]
    </div>
   <p>
    <a href="https://beian.miit.gov.cn/" target="_blank" title="https://beian.miit.gov.cn/">沪ICP备18028412号-1</a>
    </p>
  </div>

</template>

<script>
export default {
  name: "foot",
  inject: ["reload"],
  // type:不存在代表背景不透明,存在代表透明
  props: ["type"],
  data() { return {
    currentLanguage: this.$store.state.Language 
  };},
  methods: {
    ChangeLanguage(){
      //const newLanguage = this.$store.state.Language === "EN" ? "CN" :"EN";
      //const newLang = this.$bus.$emit('languageChanged', newLanguage);  // 触发 languageChanged 事件
      //this.$store.state.Language=newLanguage;  
      //this.currentLanguage=newLanguage;
      this.$store.commit('increment');
      this.currentLanguage=this.$store.state.Language
    }
  },
  mounted() {},
};
</script>

<style scoped lang='scss'>
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 7vh;
  background-color: #000;
  z-index: 999;
  background-image: url(../assets/uyz.png);
  background-repeat: no-repeat;
  background-size: auto 100%;

  .ChangeLanguage{
    position: absolute;
    right: 20px; /* 将语言切换按钮设置在右边 */
    top: 30%;
    transform: translateY(-50%);
    width: 60px;
    color: rgb(100, 93, 93);
    cursor: pointer;
    .active { /* 当语言处于 active 状态时，应用该样式 */
      font-weight: bold;
      color: antiquewhite; 
    }
  }

  img {
    height: 100%;
  }
  p {
     position: fixed;
     bottom: 0;
     right: 0;
    color: rgb(119, 117, 117);
    padding-right:1vw ;
    font-size: 0.1rem;
  }

  a:link{color:rgb(119, 117, 117)}
  a:visited { color: rgb(119, 117, 117); }
}

@media screen and (max-width: 750px) {
  .bottom {
     height: 7vh;
    height: 7svh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue